var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5 37.5C75.5 58.2105 58.7105 75 38 75C17.2895 75 0.5 58.2105 0.5 37.5C0.5 16.7895 17.2895 0 38 0C58.7105 0 75.5 16.7895 75.5 37.5Z",
    fill: "#019DD3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_308_858",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 75
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5 37.5C75.5 58.2105 58.7105 75 38 75C17.2895 75 0.5 58.2105 0.5 37.5C0.5 16.7895 17.2895 0 38 0C58.7105 0 75.5 16.7895 75.5 37.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_308_858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10.6486,
    y: 60.811,
    width: 98.25,
    height: 21,
    fill: "#084A77"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1318 39.6484L19.7568 11.1484L56.5068 11.1484L38.1318 39.6484Z",
    fill: "#98D5EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1318 28.3784L56.5068 56.8784H19.7568L38.1318 28.3784Z",
    fill: "#98D5EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2636 40.5405L53.7298 55.8861H22.7973L38.2636 40.5405Z",
    fill: "#FDDA21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4792 32.9136L31.9189 25.3379H44.8896L38.4792 32.9136Z",
    fill: "#FDDA21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7162 61.2568H17.4662C17.0162 61.2568 16.7162 60.9568 16.7162 60.5068C16.7162 58.4068 18.3662 56.7568 20.4662 56.7568H55.7162C57.8162 56.7568 59.4662 58.4068 59.4662 60.5068C59.4662 60.9568 59.1662 61.2568 58.7162 61.2568Z",
    fill: "#ADB4BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4797 8.10791L59.7297 8.10791C60.1797 8.10791 60.4797 8.40791 60.4797 8.85791C60.4797 10.9579 58.8297 12.6079 56.7297 12.6079L21.4797 12.6079C19.3797 12.6079 17.7297 10.9579 17.7297 8.85791C17.7297 8.40791 18.0297 8.10791 18.4797 8.10791Z",
    fill: "#ADB4BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7973 13.9927L24.0553 13.1757L30.9669 26.5727L22.7973 13.9927Z",
    fill: "#E2F3FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeoutIcon);
export default __webpack_public_path__ + "static/media/timeout-icon.4b9aec019264bb9d7cfe0588b43b1c00.svg";
export { ForwardRef as ReactComponent };